import { useState } from 'react';
import './BookPage.css';

interface BookPageProps {
  pageNumber: number;
  totalPages: number;
  content: string;
  isLocked: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  onDone?: () => void;
  onUnlock?: () => void;
}

export function BookPage({
  pageNumber,
  totalPages,
  content,
  isLocked,
  onPrev,
  onNext,
  onDone,
  onUnlock,
}: BookPageProps) {
  const [flipping, setFlipping] = useState(false);

  const handlePrev = () => {
    if (onPrev && pageNumber > 1) {
      setFlipping(true);
      setTimeout(() => {
        onPrev();
        setFlipping(false);
      }, 300);
    }
  };

  const handleNext = () => {
    if (onNext && pageNumber < totalPages) {
      setFlipping(true);
      setTimeout(() => {
        onNext();
        setFlipping(false);
      }, 300);
    }
  };

  return (
    <div className="book-container">
      <div className={`book-page ${flipping ? 'flipping' : ''}`}>
        {/* Page Header */}
        <div className="page-header">
          <div className="page-number">
            Page {pageNumber} of {totalPages}
          </div>
        </div>

        {/* Page Content */}
        <div className="page-content">
          {isLocked ? (
            <div className="locked-content">
              <div className="lock-icon">🔒</div>
              <p className="lock-message">This page is locked</p>
              <p className="blur-text">
                {content.substring(0, 50).split('').map((char, i) => (
                  <span key={i} style={{ opacity: Math.random() * 0.3 }}>
                    {char}
                  </span>
                ))}...
              </p>
              {onUnlock && (
                <button className="unlock-button" onClick={onUnlock}>
                  Unlock Page
                </button>
              )}
            </div>
          ) : (
            <div className="unlocked-content">
              <p className="secret-text">{content}</p>
            </div>
          )}
        </div>

        {/* Page Footer */}
        <div className="page-footer">
          <div className="page-controls">
            <button
              className="nav-button"
              onClick={handlePrev}
              disabled={pageNumber <= 1}
            >
              ← Prev
            </button>

            {onDone && (
              <button className="done-button" onClick={onDone}>
                Done
              </button>
            )}

            <button
              className="nav-button"
              onClick={handleNext}
              disabled={pageNumber >= totalPages}
            >
              Next →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
